import {
  AbilityOptionsOf,
  CreateAbility,
  createMongoAbility,
  subject,
} from '@casl/ability';
import {
  AbilityInterface,
  BaseAbilityInterface,
  AbilityAction,
} from '@kinet-open-network/shared/data-access/model';

export const createAbility: CreateAbility<AbilityInterface> = (
  rules,
  options
) => {
  const baseAbility = createMongoAbility<BaseAbilityInterface>(
    rules,
    options as AbilityOptionsOf<BaseAbilityInterface>
  );

  const ability = Object.assign(baseAbility, {
    hasMasterAccessTo(action: AbilityAction): boolean {
      return baseAbility.can(action, subject('Group', { master: true }));
    },
  });

  return ability;
};
